import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddClientComponent {}
